export default __webpack_public_path__ + "static/char-v-30-ja-2db76cd6fa7e068e145c0b772f85b94f.mp4";